import ManagerSignIn from "./manager";
import './auth.css'
const Auth = () => {
    return(
        <main className="authBody">
            <ManagerSignIn/>
        </main>
    )
}

export default Auth;